/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestCreateBaseRequest
 */
export interface RequestCreateBaseRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestCreateBaseRequest
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateBaseRequest
     */
    baseName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateBaseRequest
     */
    createdUserId: number;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateBaseRequest
     */
    mailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateBaseRequest
     */
    phoneNum?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestCreateBaseRequest
     */
    postNum?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestCreateBaseRequest
     */
    tenantId?: number;
}

/**
 * Check if a given object implements the RequestCreateBaseRequest interface.
 */
export function instanceOfRequestCreateBaseRequest(value: object): value is RequestCreateBaseRequest {
    if (!('createdUserId' in value) || value['createdUserId'] === undefined) return false;
    return true;
}

export function RequestCreateBaseRequestFromJSON(json: any): RequestCreateBaseRequest {
    return RequestCreateBaseRequestFromJSONTyped(json, false);
}

export function RequestCreateBaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestCreateBaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'address': json['address'] == null ? undefined : json['address'],
        'baseName': json['base_name'] == null ? undefined : json['base_name'],
        'createdUserId': json['created_user_id'],
        'mailAddress': json['mail_address'] == null ? undefined : json['mail_address'],
        'phoneNum': json['phone_num'] == null ? undefined : json['phone_num'],
        'postNum': json['post_num'] == null ? undefined : json['post_num'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function RequestCreateBaseRequestToJSON(json: any): RequestCreateBaseRequest {
    return RequestCreateBaseRequestToJSONTyped(json, false);
}

export function RequestCreateBaseRequestToJSONTyped(value?: RequestCreateBaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': value['address'],
        'base_name': value['baseName'],
        'created_user_id': value['createdUserId'],
        'mail_address': value['mailAddress'],
        'phone_num': value['phoneNum'],
        'post_num': value['postNum'],
        'tenant_id': value['tenantId'],
    };
}

